import React, { useContext, useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import StoreContext from '../../react-core-lib/components/app/store-context';
import HandoutContent from './handout-content';
import ErrorMessage from './error-message';
import UserApi from '../../rest-api/user-api';

const ContentLoader = () => {
    const appStateStore = useContext(StoreContext);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [linkId, setLinkId] = useState(null);
    const [clinicData, setClinicData] = useState(null); // Use state for storing clinic image URL, clinic name and account type
    const [show3DModel, setShow3DModel] = useState(true);
    const [showMainIllustration, setShowMainIllustration] = useState(true);
    const [showTutorialVideo, setShowTutorialVideo] = useState(true);
    const practitionerType = process.env.REACT_APP_CETRA_CLINIC_TYPE === 'vet' ? 'veterinarian' : 'physiotherapist'; // not in use

    // Function to validate UUID
    const validateUUID = (uuid) => {
        const regex = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
        return regex.test(uuid);
    };

    useEffect(() => {
        const fetchClinicData = async (userId) => {
            try {
                const clinicData = await UserApi.getClinicianImage(userId);
                if (clinicData) {
                    console.warn('clinicData obtained:', clinicData);
                    setClinicData(clinicData);
                }
            } catch (error) {
                console.error('Error fetching clinic image:', error);
            }
        };

        const initializeContent = async () => {
            console.log('==== initializeContent ====');
            setLoading(true);
            await appStateStore.initializeUserStoresAsync('PatientUI');

            const urlParams = new URLSearchParams(window.location.search);
            const potentialLinkId = urlParams.get('linkId');
            const userId = urlParams.get('clinicId');

            // Toggle parameters
            const show3DModelParam = urlParams.get('show3DModel');
            const showMainIllustrationParam = urlParams.get('showMainIllustration');
            const showTutorialVideoParam = urlParams.get('showTutorialVideo');

            // Set toggle states, default is true (if not specified)
            setShow3DModel(show3DModelParam !== 'false');
            setShowMainIllustration(showMainIllustrationParam !== 'false');
            setShowTutorialVideo(showTutorialVideoParam !== 'false');

            if (userId) {
                await fetchClinicData(userId);
            }

            if (potentialLinkId && validateUUID(potentialLinkId)) {
                setLinkId(potentialLinkId);
            } else {
                setError(`Invalid link ID: ${potentialLinkId}`);
            }

            setLoading(false);
        };

        initializeContent();
    }, [appStateStore]); // seems it was missing

    if (loading) {
        return <CircularProgress />;
    }

    if (error) {
        return <ErrorMessage message={`We were unable to load the handout. Please contact your practitioner.`} />;
    }

    // Pass the toggle states as props
    return (
        <HandoutContent
            linkId={linkId}
            clinicData={clinicData}
            show3DModel={show3DModel}
            showMainIllustration={showMainIllustration}
            showTutorialVideo={showTutorialVideo}
        />
    );
};

export default ContentLoader;
